import HowToRegIcon from "@mui/icons-material/HowToReg";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import SchoolIcon from "@mui/icons-material/School";
import Diversity3Icon from "@mui/icons-material/Diversity3";

const userMenuList = [
  {
    key: "group_attendance",
    type: "group",
    labelKey: "nav.attendance",
    items: [
      {
        type: "menu",
        key: "attendances",
        labelKey: "nav.attendance",
        icon: HowToRegIcon,
        location: "/attendances",
      },
    ],
  },
];

const managerMenuList = [
  ...userMenuList,
  {
    type: "group",
    key: "group_management",
    labelKey: "nav.management",
    items: [
      {
        type: "menu",
        key: "classrooms",
        labelKey: "nav.classrooms",
        icon: MeetingRoomIcon,
        location: "/management/classrooms",
      },
      {
        type: "menu",
        key: "grade_sections",
        labelKey: "nav.gradeSections",
        icon: Diversity3Icon,
        location: "/management/grade_sections",
      },
      {
        type: "menu",
        key: "students",
        labelKey: "nav.students",
        icon: SchoolIcon,
        location: "/management/students",
      },
    ],
  },
  {
    type: "group",
    key: "group_report",
    labelKey: "nav.reports",
    items: [
      {
        type: "menu",
        key: "attendance_report",
        labelKey: "nav.attendanceReport",
        icon: HowToRegIcon,
        location: "/report/attendances",
      },
    ],
  },
];

const representativeMenuList = [...managerMenuList];

const guardianMenuList = [...userMenuList];

const menuList = {
  USER: userMenuList,
  MANAGER: managerMenuList,
  REPRESENTATIVE: representativeMenuList,
  GUARDIAN: guardianMenuList,
};

export { menuList };
